// Форматирование чисел и цен. Без Intl: страницы пререндерятся в Node, и
// разделители из ICU разных версий (Node vs браузер) могут не совпасть -
// React увидит расхождение текста при гидрации. Детерминированная строка
// выглядит так же, как Intl для ru-RU: «2 490 ₽» с неразрывными пробелами.

const NBSP = '\u00a0';

// 2490 → «2 490», 1234567 → «1 234 567» (разделитель, неразрывный пробел).
export function formatThousands(value: number): string {
  const rounded = Math.round(Math.abs(value)).toString();
  const grouped = rounded.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
  return value < 0 ? `−${grouped}` : grouped;
}

// Цены в рублях. Лендинг работает с обычными числами; копейки, только на бэкенде.
export function formatRub(value: number): string {
  return `${formatThousands(value)}${NBSP}₽`;
}

// Склонение числительных: pluralRu(1, 'город', 'города', 'городов') → 'город'.
export function pluralRu(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}
